/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  Box, Dialog, DialogContent, DialogTitle,
  TextField, MenuItem, Button,
} from '@material-ui/core';

const useStyle = makeStyles(() => ({
  titleArea: {
    padding: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(47, 115, 234, 1)',
    padding: '10px',
  },
  titleStyle: {
    marginLeft: '5px',
    color: 'rgba(255, 255, 255, 1)',
  },
  inputInfoContainer: {
    padding: '10px',
  },
  inputTitleInfo: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#000',
  },
}));

export default function ModalEditInputRelation({
  data, params, dbfields, editTypeInput, editParamInput, open, onClose,
}) {
  const classes = useStyle();
  const [inputs, setInputs] = useState([]);
  const [paramData, setParamData] = useState([]);
  const typesOfFields = [
    {value: 'input', label: 'Input'},
    {value: 'useparams', label: 'Parametros'},
    {value: 'dbfield', label: 'Campo de Base de Datos'},
  ];
  useEffect(() => {
    setInputs(data);
    setParamData(params);
  });
  /* function checkTypeOf(paramValue, compareTo) {
    if (paramValue === 'string' && (compareTo === 'string' || compareTo === 'database' || compareTo === 'relation')) {
      return true;
    }
    if (paramValue === compareTo) {
      return true;
    }
    return false;
  } */
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle className={classes.titleArea}>
        <Box className={classes.titleContainer}>
          <Box className={classes.titleStyle}>
            Campos Relacion Base De Datos
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          component="div"
          style={{
            margin: '15px', padding: '5px', height: '400px', overflowY: 'scroll',
          }}
        >
          {
            inputs.map((index) => (
              <Box component="div" className={classes.inputInfoContainer}>
                <Box component="div" className={classes.inputTitleInfo}>
                  {index.relationInput.label}
                </Box>
                <div className="my-4">
                  <TextField onChange={(e) => editTypeInput(index, e.target.value)} value={index.state} select fullWidth name="type" type="text" label="Usar Relacion con:" variant="standard">
                    {
                      typesOfFields.map(({label, value}) => (
                        <MenuItem value={value} key={value}>
                          {label}
                        </MenuItem>
                      ))
                    }
                  </TextField>
                </div>
                {index.state === 'useparams' && (
                  <div>
                    <TextField select fullWidth name="type" onChange={(e) => editParamInput(index, e.target.value)} value={index?.param} type="text" label="Parametros:" variant="standard">
                      {
                        paramData.map(({value, name}) => (
                          <MenuItem value={value} key={value}>
                            {name}
                          </MenuItem>
                        ))
                      }
                    </TextField>
                  </div>
                )}
                {
                  index.state === 'dbfield' && (
                    <div>
                      <TextField
                        select
                        fullWidth
                        name="type"
                        onChange={(e) => editParamInput(index, e.target.value)}
                        value={index?.param}
                        type="text"
                        label="Campos de Base de Datos:"
                        variant="standard"
                      >
                        {
                          dbfields?.map(({value, name}) => (
                            <MenuItem value={value} key={value}>
                              {name}
                            </MenuItem>
                          ))
                        }
                      </TextField>
                    </div>
                  )
                }
              </Box>
            ))
          }
        </Box>
        <Box className={classes.buttonAreaContainer}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
            className={classes.buttonStyle}
          >
            Cerrar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
